module.exports = __webpack_public_path__ + "img/Villa_Borna_14.4da42da1.jpg";